/**
 * CreateAccountModal Messages
 *
 * This contains all the text for the CreateAccountModal component.
 */
import { defineMessages } from 'react-intl';

const scope = 'app.workspace.createAccountModal';

export default defineMessages({
  givenName: {
    id: `${scope}.givenName`,
    defaultMessage: 'First name',
  },
  givenNameFeedback: {
    id: `${scope}.givenNameFeedback`,
    defaultMessage: 'First name cannot be empty',
  },
  familyName: {
    id: `${scope}.lastName`,
    defaultMessage: 'Last name',
  },
  familyNameFeedback: {
    id: `${scope}.familyNameFeedback`,
    defaultMessage: 'Family name cannot be empty',
  },
  prefix: {
    id: `${scope}.prefix`,
    defaultMessage: 'Prefix',
  },
  honorificPrefixFeedback: {
    id: `${scope}.prefixFeedback`,
    defaultMessage: 'Prefix cannot be empty',
  },
  email: {
    id: `${scope}.email`,
    defaultMessage: 'Email',
  },
  emailFeedback: {
    id: `${scope}.emailFeedback`,
    defaultMessage: 'Email cannot be empty',
  },
  defaultPassword: {
    id: `${scope}.defaultPassword`,
    defaultMessage: 'Default password',
  },
  passwordFeedback: {
    id: `${scope}.defaultPasswordFeedback`,
    defaultMessage: 'Password cannot be empty',
  },
  roles: {
    id: `${scope}.roles`,
    defaultMessage: 'Roles',
  },
  rolesFeedback: {
    id: `${scope}.rolesFeedback`,
    defaultMessage: 'Roles cannot be empty',
  },

  rolesAdmin: {
    id: `${scope}.rolesAdmin`,
    defaultMessage: 'Admin',
  },
  rolesInstructor: {
    id: `${scope}.rolesInstructor`,
    defaultMessage: 'Instructor',
  },
  rolesDeveloper: {
    id: `${scope}.rolesDeveloper`,
    defaultMessage: 'Developer',
  },
  createAccount: {
    id: `${scope}.createAccount`,
    defaultMessage: 'create account',
  },
});
